import script from "./ActivityPostersSection.vue?vue&type=script&setup=true&lang=js"
export * from "./ActivityPostersSection.vue?vue&type=script&setup=true&lang=js"

import "./ActivityPostersSection.vue?vue&type=style&index=0&id=b2b85980&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b2b85980"]])

export default __exports__